import styled from "@mui/material/styles/styled";

import SourceIcon from "@app/analytics/MeetingReports/components/SourceIcon";

import Stack from "@rui/Stack";

export const Wrapper = styled(Stack)(({ theme }) => ({
  position: "relative",
  minWidth: "60px",
  width: "60px",

  [theme.breakpoints.up("mobile")]: {
    minWidth: "70px",
    width: "70px",
  },
}));

export const ImageContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "48px",
  border: "1px dashed",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: theme.corners.xsmall,
  overflow: "hidden",
  backgroundColor: "#FAFAFA",
}));

export const ThumbnailIcon = styled(SourceIcon)({
  position: "absolute",
  bottom: -3,
  right: -3,
});
